/* oxlint-disable */
// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddDraftVariantsData, AddDraftVariantsErrors, AddDraftVariantsResponses, AddSlotSkippedRuleData, AddSlotSkippedRuleErrors, AddSlotSkippedRuleResponses, AgentsFigmaRunData, AgentsFigmaRunErrors, AgentsFigmaRunResponses, AgentsFigmaRunStreamData, AgentsFigmaRunStreamErrors, AgentsFigmaRunStreamResponses, BulkSaveVariablesData, BulkSaveVariablesErrors, BulkSaveVariablesResponses, BulkUpdateReviewStatusData, BulkUpdateReviewStatusErrors, BulkUpdateReviewStatusResponses, ConvertDynamicImageTemplateAsNeonblueData, ConvertDynamicImageTemplateAsNeonblueErrors, ConvertDynamicImageTemplateAsNeonblueResponses, ConvertFigmaUrlToTemplateData, ConvertFigmaUrlToTemplateErrors, ConvertFigmaUrlToTemplateResponses, CreateApiKeyData, CreateApiKeyResponses, CreateBrazeIntegrationData, CreateBrazeIntegrationErrors, CreateBrazeIntegrationResponses, CreateCantoIntegrationData, CreateCantoIntegrationErrors, CreateCantoIntegrationResponses, CreateContentEvaluationCriteriaData, CreateContentEvaluationCriteriaErrors, CreateContentEvaluationCriteriaResponses, CreateContentRuleData, CreateContentRuleErrors, CreateContentRuleGroupData, CreateContentRuleGroupErrors, CreateContentRuleGroupResponses, CreateContentRuleResponses, CreateContentSchemaData, CreateContentSchemaErrors, CreateContentSchemaResponses, CreateContentStyleData, CreateContentStyleErrors, CreateContentStyleResponses, CreateContentTemplateData, CreateContentTemplateErrors, CreateContentTemplateResponses, CreateContentVariableData, CreateContentVariableErrors, CreateContentVariableResponses, CreateContentVariableTypeData, CreateContentVariableTypeErrors, CreateContentVariableTypeResponses, CreateDraftCommentData, CreateDraftCommentErrors, CreateDraftCommentResponses, CreateDraftExperimentData, CreateDraftExperimentErrors, CreateDraftExperimentResponses, CreateDynamicImageIntegrationData, CreateDynamicImageIntegrationErrors, CreateDynamicImageIntegrationResponses, CreateExperimentData, CreateExperimentErrors, CreateExperimentResponses, CreateExperimentVariantData, CreateExperimentVariantErrors, CreateExperimentVariantResponses, CreateKlaviyoDashboardIntegrationData, CreateKlaviyoDashboardIntegrationErrors, CreateKlaviyoDashboardIntegrationResponses, CreateKlaviyoIntegrationData, CreateKlaviyoIntegrationErrors, CreateKlaviyoIntegrationResponses, CreateSnowflakeShareOutboundIntegrationData, CreateSnowflakeShareOutboundIntegrationErrors, CreateSnowflakeShareOutboundIntegrationResponses, CreateWarehouseFeatureSpecData, CreateWarehouseFeatureSpecErrors, CreateWarehouseFeatureSpecResponses, CreateWarehouseIdTypeData, CreateWarehouseIdTypeErrors, CreateWarehouseIdTypeResponses, CreateWarehouseMetricData, CreateWarehouseMetricErrors, CreateWarehouseMetricResponses, CreateWarehouseSourceTableData, CreateWarehouseSourceTableErrors, CreateWarehouseSourceTableResponses, DeleteApiKeyData, DeleteApiKeyErrors, DeleteApiKeyResponses, DeleteCommentData, DeleteCommentErrors, DeleteCommentResponses, DeleteContentAssetData, DeleteContentAssetErrors, DeleteContentAssetResponses, DeleteContentEvaluationCriteriaByIdData, DeleteContentEvaluationCriteriaByIdErrors, DeleteContentEvaluationCriteriaByIdResponses, DeleteContentRuleData, DeleteContentRuleErrors, DeleteContentRuleGroupData, DeleteContentRuleGroupErrors, DeleteContentRuleGroupResponses, DeleteContentRuleResponses, DeleteContentSchemaByIdData, DeleteContentSchemaByIdErrors, DeleteContentSchemaByIdResponses, DeleteContentStyleData, DeleteContentStyleErrors, DeleteContentStyleResponses, DeleteContentTemplateByIdData, DeleteContentTemplateByIdErrors, DeleteContentTemplateByIdResponses, DeleteContentVariableData, DeleteContentVariableErrors, DeleteContentVariableResponses, DeleteContentVariableTypeData, DeleteContentVariableTypeErrors, DeleteContentVariableTypeResponses, DeleteExperimentData, DeleteExperimentErrors, DeleteExperimentResponses, DeleteIntegrationData, DeleteIntegrationErrors, DeleteIntegrationResponses, DeleteWarehouseIdTypeData, DeleteWarehouseIdTypeErrors, DeleteWarehouseIdTypeResponses, DeleteWarehouseMetricData, DeleteWarehouseMetricErrors, DeleteWarehouseMetricResponses, DeleteWarehouseSourceTableData, DeleteWarehouseSourceTableErrors, DeleteWarehouseSourceTableResponses, EnqueueDraftEvaluationData, EnqueueDraftEvaluationErrors, EnqueueDraftEvaluationResponses, EnqueueDraftGenerationData, EnqueueDraftGenerationErrors, EnqueueDraftGenerationResponses, EnqueueRegenerateWithFeedbackData, EnqueueRegenerateWithFeedbackErrors, EnqueueRegenerateWithFeedbackResponses, EnqueueVariantEvaluationData, EnqueueVariantEvaluationErrors, EnqueueVariantEvaluationResponses, EvaluateMarketingContentData, EvaluateMarketingContentErrors, EvaluateMarketingContentResponses, ExecuteExperimentMetricData, ExecuteExperimentMetricErrors, ExecuteExperimentMetricResponses, ExecuteWarehouseMetricTimeseriesData, ExecuteWarehouseMetricTimeseriesErrors, ExecuteWarehouseMetricTimeseriesResponses, GenerateAdversarialContentData, GenerateAdversarialContentErrors, GenerateAdversarialContentResponses, GenerateCombinedAdversarialContentData, GenerateCombinedAdversarialContentErrors, GenerateCombinedAdversarialContentResponses, GenerateData, GenerateErrors, GenerateResponses, GenerateSampleTemplateParametersData, GenerateSampleTemplateParametersErrors, GenerateSampleTemplateParametersResponses, GenerateStreamData, GenerateStreamErrors, GenerateStreamResponses, GetActiveStreamData, GetActiveStreamErrors, GetActiveStreamResponses, GetAppUserData, GetAppUserErrors, GetAppUserResponses, GetContentAssetData, GetContentAssetErrors, GetContentAssetResponses, GetContentEvaluationCriteriaByIdData, GetContentEvaluationCriteriaByIdErrors, GetContentEvaluationCriteriaByIdResponses, GetContentRuleData, GetContentRuleErrors, GetContentRuleGroupData, GetContentRuleGroupErrors, GetContentRuleGroupResponses, GetContentRuleResponses, GetContentSchemaByIdData, GetContentSchemaByIdErrors, GetContentSchemaByIdResponses, GetContentStyleData, GetContentStyleErrors, GetContentStyleResponses, GetContentTemplateByIdData, GetContentTemplateByIdErrors, GetContentTemplateByIdResponses, GetContentVariableData, GetContentVariableErrors, GetContentVariableResponses, GetContentVariableTypeData, GetContentVariableTypeErrors, GetContentVariableTypeResponses, GetDashboardStatsData, GetDashboardStatsResponses, GetDiagnosticsLogEntryData, GetDiagnosticsLogEntryErrors, GetDiagnosticsLogEntryResponses, GetDraftData, GetDraftErrors, GetDraftResponses, GetDynamicImageTemplateData, GetDynamicImageTemplateErrors, GetDynamicImageTemplateResponses, GetExperimentContextData, GetExperimentContextErrors, GetExperimentContextResponses, GetExperimentDetailsData, GetExperimentDetailsErrors, GetExperimentDetailsResponses, GetExperimentExposuresByDayData, GetExperimentExposuresByDayErrors, GetExperimentExposuresByDayResponses, GetExperimentMetricDailyByVariantData, GetExperimentMetricDailyByVariantErrors, GetExperimentMetricDailyByVariantResponses, GetExperimentMetricTimeseriesDailyData, GetExperimentMetricTimeseriesDailyErrors, GetExperimentMetricTimeseriesDailyResponses, GetExperimentVariantEditUrlData, GetExperimentVariantEditUrlErrors, GetExperimentVariantEditUrlResponses, GetExperimentVariantMetricsData, GetExperimentVariantMetricsResponses, GetExperimentVariantReportData, GetExperimentVariantReportErrors, GetExperimentVariantReportResponses, GetFeedbackPromptData, GetFeedbackPromptErrors, GetFeedbackPromptResponses, GetFigmaConvertLogData, GetFigmaConvertLogErrors, GetFigmaConvertLogResponses, GetFigmaConvertSessionData, GetFigmaConvertSessionErrors, GetFigmaConvertSessionResponses, GetFigmaConvertStatusData, GetFigmaConvertStatusErrors, GetFigmaConvertStatusResponses, GetJobData, GetJobErrors, GetJobResponses, GetReportInsightsAnalysisData, GetReportInsightsAnalysisErrors, GetReportInsightsAnalysisResponses, GetReportInsightsChartData, GetReportInsightsChartErrors, GetReportInsightsChartResponses, GetReportInsightsData, GetReportInsightsErrors, GetReportInsightsHypothesesData, GetReportInsightsHypothesesErrors, GetReportInsightsHypothesesResponses, GetReportInsightsRecapData, GetReportInsightsRecapErrors, GetReportInsightsRecapResponses, GetReportInsightsResponses, GetReportInsightsSummaryData, GetReportInsightsSummaryErrors, GetReportInsightsSummaryResponses, GetSlotEvalOverridesData, GetSlotEvalOverridesErrors, GetSlotEvalOverridesResponses, GetVariantReportData, GetVariantReportResponses, GetWarehouseFeatureSpecData, GetWarehouseFeatureSpecErrors, GetWarehouseFeatureSpecResponses, GetWarehouseIdTypeData, GetWarehouseIdTypeErrors, GetWarehouseIdTypeResponses, GetWarehouseMetricData, GetWarehouseMetricErrors, GetWarehouseMetricResponses, GetWarehouseSourceTableData, GetWarehouseSourceTableErrors, GetWarehouseSourceTableResponses, GetWarehouseStoreData, GetWarehouseStoreResponses, HealthLivenessData, HealthLivenessResponses, HealthReadinessData, HealthReadinessResponses, ImportDynamicImageTemplateAsNeonblueData, ImportDynamicImageTemplateAsNeonblueErrors, ImportDynamicImageTemplateAsNeonblueResponses, KlaviyoOauthCallbackData, KlaviyoOauthCallbackErrors, KlaviyoOauthCallbackResponses, KlaviyoOauthInitiateData, KlaviyoOauthInitiateResponses, ListApiKeysData, ListApiKeysResponses, ListBatchGenerationsData, ListBatchGenerationsErrors, ListBatchGenerationsResponses, ListChatModelsData, ListChatModelsResponses, ListContentAssetsData, ListContentAssetsErrors, ListContentAssetsResponses, ListContentEvaluationCriteriaData, ListContentEvaluationCriteriaErrors, ListContentEvaluationCriteriaResponses, ListContentRuleGroupsData, ListContentRuleGroupsResponses, ListContentRulesData, ListContentRulesResponses, ListContentSchemasData, ListContentSchemasErrors, ListContentSchemasResponses, ListContentStylesData, ListContentStylesErrors, ListContentStylesResponses, ListContentTemplatesData, ListContentTemplatesErrors, ListContentTemplatesResponses, ListContentVariablesData, ListContentVariablesResponses, ListContentVariableTypesData, ListContentVariableTypesErrors, ListContentVariableTypesResponses, ListDraftGenerationsData, ListDraftGenerationsErrors, ListDraftGenerationsResponses, ListDraftsData, ListDraftsErrors, ListDraftsResponses, ListDraftVariantCommentsData, ListDraftVariantCommentsErrors, ListDraftVariantCommentsResponses, ListDynamicImageFontsData, ListDynamicImageFontsResponses, ListDynamicImageTemplatesData, ListDynamicImageTemplatesErrors, ListDynamicImageTemplateSlicesData, ListDynamicImageTemplateSlicesErrors, ListDynamicImageTemplateSlicesResponses, ListDynamicImageTemplatesResponses, ListExperimentFeaturesData, ListExperimentFeaturesResponses, ListExperimentMetricsData, ListExperimentMetricsResponses, ListExperimentMetricsSummaryData, ListExperimentMetricsSummaryErrors, ListExperimentMetricsSummaryResponses, ListExperimentsData, ListExperimentsErrors, ListExperimentsResponses, ListExperimentVariantsData, ListExperimentVariantsErrors, ListExperimentVariantsResponses, ListFigmaConvertRunsData, ListFigmaConvertRunsResponses, ListIntegrationsData, ListIntegrationsResponses, ListJobsData, ListJobsResponses, ListSourceTemplatesData, ListSourceTemplatesErrors, ListSourceTemplatesResponses, ListSourceTypesData, ListSourceTypesResponses, ListVariablesForTypeData, ListVariablesForTypeErrors, ListVariablesForTypeResponses, ListWarehouseFeatureSpecsData, ListWarehouseFeatureSpecsErrors, ListWarehouseFeatureSpecsResponses, ListWarehouseIdTypesData, ListWarehouseIdTypesErrors, ListWarehouseIdTypesResponses, ListWarehouseMetricsData, ListWarehouseMetricsErrors, ListWarehouseMetricsResponses, ListWarehouseSourceTablesData, ListWarehouseSourceTablesErrors, ListWarehouseSourceTablesResponses, PreviewContentTemplateData, PreviewContentTemplateErrors, PreviewContentTemplateResponses, PreviewWarehouseFeatureData, PreviewWarehouseFeatureErrors, PreviewWarehouseFeatureResponses, PreviewWarehouseMetricData, PreviewWarehouseMetricErrors, PreviewWarehouseMetricResponses, PromoteDraftExperimentData, PromoteDraftExperimentErrors, PromoteDraftExperimentResponses, QueryDiagnosticsLogsData, QueryDiagnosticsLogsErrors, QueryDiagnosticsLogsResponses, RegenerateDraftVariantData, RegenerateDraftVariantErrors, RegenerateDraftVariantResponses, RemoveExperimentVariantsData, RemoveExperimentVariantsErrors, RemoveExperimentVariantsResponses, RemoveSlotSkippedRuleData, RemoveSlotSkippedRuleErrors, RemoveSlotSkippedRuleResponses, RenderContentTemplateData, RenderContentTemplateErrors, RenderContentTemplateResponses, ResolveVariableSlugsData, ResolveVariableSlugsErrors, ResolveVariableSlugsResponses, ResyncDynamicImageTemplateAsNeonblueData, ResyncDynamicImageTemplateAsNeonblueErrors, ResyncDynamicImageTemplateAsNeonblueResponses, RootData, RootResponses, RunAdversarialTestData, RunAdversarialTestErrors, RunAdversarialTestResponses, SaveNeonblueTemplateData, SaveNeonblueTemplateErrors, SaveNeonblueTemplateResponses, SetDraftCurrentGenerationsData, SetDraftCurrentGenerationsErrors, SetDraftCurrentGenerationsResponses, SetExperimentStatusData, SetExperimentStatusErrors, SetExperimentStatusResponses, SetExperimentVariantStatusData, SetExperimentVariantStatusErrors, SetExperimentVariantStatusResponses, ShopifyInstallData, ShopifyInstallErrors, ShopifyInstallResponses, ShopifyOauthCallbackData, ShopifyOauthCallbackResponses, ShopifyOauthInitiateData, ShopifyOauthInitiateResponses, StreamDiagnosticsLogsData, StreamDiagnosticsLogsErrors, StreamDiagnosticsLogsResponses, StreamEvaluationByExperimentData, StreamEvaluationByExperimentErrors, StreamEvaluationByExperimentResponses, StreamEvaluationByVariantData, StreamEvaluationByVariantErrors, StreamEvaluationByVariantResponses, StreamFigmaConvertData, StreamFigmaConvertErrors, StreamFigmaConvertResponses, StreamGenerationByExperimentData, StreamGenerationByExperimentErrors, StreamGenerationByExperimentResponses, StreamRegenerateByVariantData, StreamRegenerateByVariantErrors, StreamRegenerateByVariantResponses, SyncContentTemplateFromSourceData, SyncContentTemplateFromSourceErrors, SyncContentTemplateFromSourceResponses, SyncSourceTemplatesData, SyncSourceTemplatesErrors, SyncSourceTemplatesResponses, UpdateCommentData, UpdateCommentErrors, UpdateCommentResponses, UpdateCommentStatusData, UpdateCommentStatusErrors, UpdateCommentStatusResponses, UpdateContentAssetData, UpdateContentAssetErrors, UpdateContentAssetResponses, UpdateContentEvaluationCriteriaData, UpdateContentEvaluationCriteriaErrors, UpdateContentEvaluationCriteriaResponses, UpdateContentRuleData, UpdateContentRuleErrors, UpdateContentRuleGroupData, UpdateContentRuleGroupErrors, UpdateContentRuleGroupResponses, UpdateContentRuleResponses, UpdateContentSchemaData, UpdateContentSchemaErrors, UpdateContentSchemaResponses, UpdateContentStyleData, UpdateContentStyleErrors, UpdateContentStyleResponses, UpdateContentTemplateData, UpdateContentTemplateErrors, UpdateContentTemplateResponses, UpdateContentVariableData, UpdateContentVariableErrors, UpdateContentVariableResponses, UpdateContentVariableTypeData, UpdateContentVariableTypeErrors, UpdateContentVariableTypeResponses, UpdateDraftExperimentData, UpdateDraftExperimentErrors, UpdateDraftExperimentResponses, UpdateDraftVariantData, UpdateDraftVariantErrors, UpdateDraftVariantResponses, UpdateDraftVariantReviewStatusData, UpdateDraftVariantReviewStatusErrors, UpdateDraftVariantReviewStatusResponses, UpdateExperimentData, UpdateExperimentErrors, UpdateExperimentResponses, UpdateExperimentVariantsData, UpdateExperimentVariantsErrors, UpdateExperimentVariantsResponses, UpdateIntegrationData, UpdateIntegrationErrors, UpdateIntegrationResponses, UpdateWarehouseFeatureSpecData, UpdateWarehouseFeatureSpecErrors, UpdateWarehouseFeatureSpecResponses, UpdateWarehouseIdTypeData, UpdateWarehouseIdTypeErrors, UpdateWarehouseIdTypeResponses, UpdateWarehouseMetricData, UpdateWarehouseMetricErrors, UpdateWarehouseMetricResponses, UpdateWarehouseSourceTableData, UpdateWarehouseSourceTableErrors, UpdateWarehouseSourceTableResponses, UploadImageData, UploadImageErrors, UploadImageResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Figma Run
 *
 * Run the managed agent against a Figma design via the shared Figma MCP vault.
 */
export const agentsFigmaRun = <ThrowOnError extends boolean = false>(options: Options<AgentsFigmaRunData, ThrowOnError>) => (options.client ?? client).post<AgentsFigmaRunResponses, AgentsFigmaRunErrors, ThrowOnError>({
    url: '/api/v2/agents/figma/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Figma Run Stream
 *
 * Run the managed agent against a Figma design, streaming progress over SSE.
 *
 * Emits the normalized SSE protocol: ``progress`` events per Figma MCP tool
 * call / agent message, then a terminal ``complete`` (or ``error``).
 */
export const agentsFigmaRunStream = <ThrowOnError extends boolean = false>(options: Options<AgentsFigmaRunStreamData, ThrowOnError>) => (options.client ?? client).post<AgentsFigmaRunStreamResponses, AgentsFigmaRunStreamErrors, ThrowOnError>({
    url: '/api/v2/agents/figma/run/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Api Keys
 */
export const listApiKeys = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysData, ThrowOnError>) => (options?.client ?? client).get<ListApiKeysResponses, unknown, ThrowOnError>({ url: '/api/v2/api-keys', ...options });

/**
 * Create Api Key
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options?: Options<CreateApiKeyData, ThrowOnError>) => (options?.client ?? client).post<CreateApiKeyResponses, unknown, ThrowOnError>({ url: '/api/v2/api-keys', ...options });

/**
 * Delete Api Key
 */
export const deleteApiKey = <ThrowOnError extends boolean = false>(options: Options<DeleteApiKeyData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiKeyResponses, DeleteApiKeyErrors, ThrowOnError>({ url: '/api/v2/api-keys/{api_key}', ...options });

/**
 * Get App User
 */
export const getAppUser = <ThrowOnError extends boolean = false>(options: Options<GetAppUserData, ThrowOnError>) => (options.client ?? client).get<GetAppUserResponses, GetAppUserErrors, ThrowOnError>({ url: '/api/v2/app-users/{app_user_id}', ...options });

/**
 * Get Dashboard Stats
 */
export const getDashboardStats = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardStatsData, ThrowOnError>) => (options?.client ?? client).get<GetDashboardStatsResponses, unknown, ThrowOnError>({ url: '/api/v2/dashboard', ...options });

/**
 * List available LLM models for content generation. Call this before configure_draft_slot_generation to show the user their options.
 *
 * List all available chat model identifiers.
 */
export const listChatModels = <ThrowOnError extends boolean = false>(options?: Options<ListChatModelsData, ThrowOnError>) => (options?.client ?? client).get<ListChatModelsResponses, unknown, ThrowOnError>({ url: '/api/v2/draft-experiments/chat-models', ...options });

/**
 * List all draft experiments with name, status, and variant count
 */
export const listDrafts = <ThrowOnError extends boolean = false>(options?: Options<ListDraftsData, ThrowOnError>) => (options?.client ?? client).get<ListDraftsResponses, ListDraftsErrors, ThrowOnError>({ url: '/api/v2/draft-experiments', ...options });

/**
 * Create a new draft experiment with name, hypothesis, and tags
 */
export const createDraftExperiment = <ThrowOnError extends boolean = false>(options: Options<CreateDraftExperimentData, ThrowOnError>) => (options.client ?? client).post<CreateDraftExperimentResponses, CreateDraftExperimentErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Evaluate arbitrary content against a rule group via the DAG hard-rules engine.
 */
export const evaluateMarketingContent = <ThrowOnError extends boolean = false>(options: Options<EvaluateMarketingContentData, ThrowOnError>) => (options.client ?? client).post<EvaluateMarketingContentResponses, EvaluateMarketingContentErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/marketing-eval/evaluate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate one violating email per rule, used to seed eval recall tests.
 */
export const generateAdversarialContent = <ThrowOnError extends boolean = false>(options: Options<GenerateAdversarialContentData, ThrowOnError>) => (options.client ?? client).post<GenerateAdversarialContentResponses, GenerateAdversarialContentErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/marketing-eval/generate-adversarial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate ONE email designed to violate every selected rule at once.
 */
export const generateCombinedAdversarialContent = <ThrowOnError extends boolean = false>(options: Options<GenerateCombinedAdversarialContentData, ThrowOnError>) => (options.client ?? client).post<GenerateCombinedAdversarialContentResponses, GenerateCombinedAdversarialContentErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/marketing-eval/generate-combined-adversarial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Per-rule recall test: generate violating content, evaluate, report fire/cross-fire.
 */
export const runAdversarialTest = <ThrowOnError extends boolean = false>(options: Options<RunAdversarialTestData, ThrowOnError>) => (options.client ?? client).post<RunAdversarialTestResponses, RunAdversarialTestErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/marketing-eval/adversarial-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * SSE stream of generation progress events for a draft experiment
 *
 * Stream generation events for an experiment. Reconnectable via Last-Event-ID.
 */
export const streamGenerationByExperiment = <ThrowOnError extends boolean = false>(options: Options<StreamGenerationByExperimentData, ThrowOnError>) => (options.client ?? client).get<StreamGenerationByExperimentResponses, StreamGenerationByExperimentErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/generate/stream', ...options });

/**
 * Run generation with SSE streaming of token-by-token progress
 */
export const generateStream = <ThrowOnError extends boolean = false>(options: Options<GenerateStreamData, ThrowOnError>) => (options.client ?? client).post<GenerateStreamResponses, GenerateStreamErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/generate/stream', ...options });

/**
 * SSE stream of evaluation progress events for a draft experiment
 *
 * Stream evaluation events for an experiment. Reconnectable via Last-Event-ID.
 */
export const streamEvaluationByExperiment = <ThrowOnError extends boolean = false>(options: Options<StreamEvaluationByExperimentData, ThrowOnError>) => (options.client ?? client).get<StreamEvaluationByExperimentResponses, StreamEvaluationByExperimentErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/evaluate/stream', ...options });

/**
 * List every currently-running stream for an experiment: generation, evaluation, per-variant evaluation, per-variant regeneration.
 */
export const getActiveStream = <ThrowOnError extends boolean = false>(options: Options<GetActiveStreamData, ThrowOnError>) => (options.client ?? client).get<GetActiveStreamResponses, GetActiveStreamErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/active-stream', ...options });

/**
 * Get full draft experiment details including variants, slots, and config
 */
export const getDraft = <ThrowOnError extends boolean = false>(options: Options<GetDraftData, ThrowOnError>) => (options.client ?? client).get<GetDraftResponses, GetDraftErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}', ...options });

/**
 * Update experiment config: name, variants, content slots, prompt, model
 */
export const updateDraftExperiment = <ThrowOnError extends boolean = false>(options: Options<UpdateDraftExperimentData, ThrowOnError>) => (options.client ?? client).put<UpdateDraftExperimentResponses, UpdateDraftExperimentErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start async content generation for all axis-based variants at once (variants with personalization variable assignments; hand-authored variants keep their own content). Call this ONCE per experiment, not per variant. Use list_draft_generations to check results after ~20 seconds.
 *
 * Enqueue a generation job and start streaming via GET /{experiment_id}/generate/stream.
 */
export const enqueueDraftGeneration = <ThrowOnError extends boolean = false>(options: Options<EnqueueDraftGenerationData, ThrowOnError>) => (options.client ?? client).post<EnqueueDraftGenerationResponses, EnqueueDraftGenerationErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/generate/queue', ...options });

/**
 * Run synchronous content generation and return results immediately
 */
export const generate = <ThrowOnError extends boolean = false>(options: Options<GenerateData, ThrowOnError>) => (options.client ?? client).post<GenerateResponses, GenerateErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/generate', ...options });

/**
 * List all generated content variants for a draft experiment
 */
export const listDraftGenerations = <ThrowOnError extends boolean = false>(options: Options<ListDraftGenerationsData, ThrowOnError>) => (options.client ?? client).get<ListDraftGenerationsResponses, ListDraftGenerationsErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/generations', ...options });

/**
 * List generations from a specific generation batch
 *
 * List all generations in a specific batch.
 */
export const listBatchGenerations = <ThrowOnError extends boolean = false>(options: Options<ListBatchGenerationsData, ThrowOnError>) => (options.client ?? client).get<ListBatchGenerationsResponses, ListBatchGenerationsErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/batches/{batch_id}/generations', ...options });

/**
 * Start async evaluation of ALL current generations against criteria and hard rules. Call ONCE per experiment. Use list_draft_generations to check evaluation_result after ~20 seconds.
 *
 * Enqueue a DAG evaluation job; reuses the existing eval SSE stream.
 */
export const enqueueDraftEvaluation = <ThrowOnError extends boolean = false>(options: Options<EnqueueDraftEvaluationData, ThrowOnError>) => (options.client ?? client).post<EnqueueDraftEvaluationResponses, EnqueueDraftEvaluationErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/evaluate-dag/queue', ...options });

/**
 * Activate new generations after regenerate_draft_variant. Pass the generation_ids from the regeneration response to make them the current active generations.
 */
export const setDraftCurrentGenerations = <ThrowOnError extends boolean = false>(options: Options<SetDraftCurrentGenerationsData, ThrowOnError>) => (options.client ?? client).post<SetDraftCurrentGenerationsResponses, SetDraftCurrentGenerationsErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/set-current-generations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List review comments on a specific variant. Check existing feedback before regenerating.
 */
export const listDraftVariantComments = <ThrowOnError extends boolean = false>(options: Options<ListDraftVariantCommentsData, ThrowOnError>) => (options.client ?? client).get<ListDraftVariantCommentsResponses, ListDraftVariantCommentsErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/comments', ...options });

/**
 * Add a review comment on a variant without triggering regeneration. Batch comments across variants first, then use regenerate_draft_variant to apply them.
 */
export const createDraftComment = <ThrowOnError extends boolean = false>(options: Options<CreateDraftCommentData, ThrowOnError>) => (options.client ?? client).post<CreateDraftCommentResponses, CreateDraftCommentErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Comment
 */
export const deleteComment = <ThrowOnError extends boolean = false>(options: Options<DeleteCommentData, ThrowOnError>) => (options.client ?? client).delete<DeleteCommentResponses, DeleteCommentErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/comments/{comment_id}', ...options });

/**
 * Edit the text of an existing review comment
 */
export const updateComment = <ThrowOnError extends boolean = false>(options: Options<UpdateCommentData, ThrowOnError>) => (options.client ?? client).patch<UpdateCommentResponses, UpdateCommentErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/comments/{comment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a comment as resolved, pending, or ignored
 */
export const updateCommentStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateCommentStatusData, ThrowOnError>) => (options.client ?? client).patch<UpdateCommentStatusResponses, UpdateCommentStatusErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/comments/{comment_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add hand-authored variants to a draft experiment, bypassing the LLM generation flow. Each variant supplies content as `value` keyed by slot. Slot keys must match the experiment's content_slots exactly. Each call mints one DraftGenerationBatch shared by all created variants.
 */
export const addDraftVariants = <ThrowOnError extends boolean = false>(options: Options<AddDraftVariantsData, ThrowOnError>) => (options.client ?? client).post<AddDraftVariantsResponses, AddDraftVariantsErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a draft variant. Partial update. Send only fields that change. If `value` is supplied, the current generation's value is overwritten in place. evaluation_result is cleared and status is reset to GENERATED.
 */
export const updateDraftVariant = <ThrowOnError extends boolean = false>(options: Options<UpdateDraftVariantData, ThrowOnError>) => (options.client ?? client).patch<UpdateDraftVariantResponses, UpdateDraftVariantErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve or reject a single variant. When all variants are approved, the experiment can be promoted to a live experiment using promote_draft.
 */
export const updateDraftVariantReviewStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateDraftVariantReviewStatusData, ThrowOnError>) => (options.client ?? client).patch<UpdateDraftVariantReviewStatusResponses, UpdateDraftVariantReviewStatusErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/review-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve or reject multiple variants at once
 *
 * Update review status for multiple variants at once.
 */
export const bulkUpdateReviewStatus = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateReviewStatusData, ThrowOnError>) => (options.client ?? client).patch<BulkUpdateReviewStatusResponses, BulkUpdateReviewStatusErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/review-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Promote a draft experiment to a live experiment. All variants must be approved.
 */
export const promoteDraftExperiment = <ThrowOnError extends boolean = false>(options: Options<PromoteDraftExperimentData, ThrowOnError>) => (options.client ?? client).post<PromoteDraftExperimentResponses, PromoteDraftExperimentErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/promote', ...options });

/**
 * Start async regenerate-with-feedback. Subscribe via GET /regenerate/stream for progress.
 */
export const enqueueRegenerateWithFeedback = <ThrowOnError extends boolean = false>(options: Options<EnqueueRegenerateWithFeedbackData, ThrowOnError>) => (options.client ?? client).post<EnqueueRegenerateWithFeedbackResponses, EnqueueRegenerateWithFeedbackErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/regenerate-with-feedback/queue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * SSE stream of regenerate-with-feedback progress events
 */
export const streamRegenerateByVariant = <ThrowOnError extends boolean = false>(options: Options<StreamRegenerateByVariantData, ThrowOnError>) => (options.client ?? client).get<StreamRegenerateByVariantResponses, StreamRegenerateByVariantErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/regenerate/stream', ...options });

/**
 * Start async DAG evaluation of one variant's current generation. Subscribe via GET /evaluate/stream for progress.
 */
export const enqueueVariantEvaluation = <ThrowOnError extends boolean = false>(options: Options<EnqueueVariantEvaluationData, ThrowOnError>) => (options.client ?? client).post<EnqueueVariantEvaluationResponses, EnqueueVariantEvaluationErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/evaluate-dag/queue', ...options });

/**
 * SSE stream of per-variant evaluation progress events
 */
export const streamEvaluationByVariant = <ThrowOnError extends boolean = false>(options: Options<StreamEvaluationByVariantData, ThrowOnError>) => (options.client ?? client).get<StreamEvaluationByVariantResponses, StreamEvaluationByVariantErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/evaluate/stream', ...options });

/**
 * Regenerate a variant's content with specific feedback. Returns a new inactive generation. After regenerating, call set_draft_current_generations with the returned generation_ids to activate them.
 *
 * Apply a revision to produce a new (inactive) generation.
 *
 * Phase 2 of the preview → apply → activate flow. The client passes the
 * (possibly edited) CommentBody from the preview step. Returns the
 * new generation value for diff preview.
 *
 * Per-slot 'not a violation' overrides are read from the parent generation's
 * own evaluation_result.slots[*].eval_overrides — the request body does NOT
 * carry a skip list. Mark rules as not-a-violation via the dedicated
 * /generations/{generation_id}/slots/{slot_key}/eval-overrides endpoints.
 */
export const regenerateDraftVariant = <ThrowOnError extends boolean = false>(options: Options<RegenerateDraftVariantData, ThrowOnError>) => (options.client ?? client).post<RegenerateDraftVariantResponses, RegenerateDraftVariantErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/regenerate-with-feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read 'not a violation' overrides stored on a specific generation's slot.
 */
export const getSlotEvalOverrides = <ThrowOnError extends boolean = false>(options: Options<GetSlotEvalOverridesData, ThrowOnError>) => (options.client ?? client).get<GetSlotEvalOverridesResponses, GetSlotEvalOverridesErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/generations/{generation_id}/slots/{slot_key}/eval-overrides', ...options });

/**
 * Mark a rule as 'not a violation' on this slot. Cascades across every variant's current generation in the experiment so the same rule is skipped everywhere it might fire. Idempotent.
 */
export const addSlotSkippedRule = <ThrowOnError extends boolean = false>(options: Options<AddSlotSkippedRuleData, ThrowOnError>) => (options.client ?? client).post<AddSlotSkippedRuleResponses, AddSlotSkippedRuleErrors, ThrowOnError>({
    url: '/api/v2/draft-experiments/{experiment_id}/generations/{generation_id}/slots/{slot_key}/eval-overrides/skipped-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore a previously-skipped rule. Cascades across every variant's current generation in the experiment to undo the skip everywhere. Idempotent.
 */
export const removeSlotSkippedRule = <ThrowOnError extends boolean = false>(options: Options<RemoveSlotSkippedRuleData, ThrowOnError>) => (options.client ?? client).delete<RemoveSlotSkippedRuleResponses, RemoveSlotSkippedRuleErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/generations/{generation_id}/slots/{slot_key}/eval-overrides/skipped-rules/{rule_id}', ...options });

/**
 * Get unresolved comments and rule violations for a variant to build feedback
 *
 * Preview a revision: gather unresolved comments + evaluate rules.
 *
 * Returns a unified CommentBody the client can render in a Lexical editor
 * and pass back to regenerate-with-feedback.
 */
export const getFeedbackPrompt = <ThrowOnError extends boolean = false>(options: Options<GetFeedbackPromptData, ThrowOnError>) => (options.client ?? client).get<GetFeedbackPromptResponses, GetFeedbackPromptErrors, ThrowOnError>({ url: '/api/v2/draft-experiments/{experiment_id}/variants/{variant_id}/feedback-prompt', ...options });

/**
 * Render Content Template
 *
 * Render a content template directly by its UUID.
 * Unlike /render (which resolves via a content schema), this endpoint takes
 * the content template ID directly and renders it with the given parameters.
 * Returns the appropriate output type (EmailOutput, PushOutput, etc.)
 * based on the template type.
 */
export const renderContentTemplate = <ThrowOnError extends boolean = false>(options: Options<RenderContentTemplateData, ThrowOnError>) => (options.client ?? client).post<RenderContentTemplateResponses, RenderContentTemplateErrors, ThrowOnError>({
    url: '/api/v2/content-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List evaluation criteria used to score generated content quality
 */
export const listContentEvaluationCriteria = <ThrowOnError extends boolean = false>(options?: Options<ListContentEvaluationCriteriaData, ThrowOnError>) => (options?.client ?? client).get<ListContentEvaluationCriteriaResponses, ListContentEvaluationCriteriaErrors, ThrowOnError>({ url: '/api/v2/content-evaluation-criteria', ...options });

/**
 * Create Content Evaluation Criteria
 */
export const createContentEvaluationCriteria = <ThrowOnError extends boolean = false>(options: Options<CreateContentEvaluationCriteriaData, ThrowOnError>) => (options.client ?? client).post<CreateContentEvaluationCriteriaResponses, CreateContentEvaluationCriteriaErrors, ThrowOnError>({
    url: '/api/v2/content-evaluation-criteria',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Content Evaluation Criteria By Id
 */
export const deleteContentEvaluationCriteriaById = <ThrowOnError extends boolean = false>(options: Options<DeleteContentEvaluationCriteriaByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentEvaluationCriteriaByIdResponses, DeleteContentEvaluationCriteriaByIdErrors, ThrowOnError>({ url: '/api/v2/content-evaluation-criteria/{criteria_id}', ...options });

/**
 * Get a specific evaluation criterion's text
 */
export const getContentEvaluationCriteriaById = <ThrowOnError extends boolean = false>(options: Options<GetContentEvaluationCriteriaByIdData, ThrowOnError>) => (options.client ?? client).get<GetContentEvaluationCriteriaByIdResponses, GetContentEvaluationCriteriaByIdErrors, ThrowOnError>({ url: '/api/v2/content-evaluation-criteria/{criteria_id}', ...options });

/**
 * Update Content Evaluation Criteria
 */
export const updateContentEvaluationCriteria = <ThrowOnError extends boolean = false>(options: Options<UpdateContentEvaluationCriteriaData, ThrowOnError>) => (options.client ?? client).patch<UpdateContentEvaluationCriteriaResponses, UpdateContentEvaluationCriteriaErrors, ThrowOnError>({
    url: '/api/v2/content-evaluation-criteria/{criteria_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List uploaded image assets
 */
export const listContentAssets = <ThrowOnError extends boolean = false>(options?: Options<ListContentAssetsData, ThrowOnError>) => (options?.client ?? client).get<ListContentAssetsResponses, ListContentAssetsErrors, ThrowOnError>({ url: '/api/v2/content-assets', ...options });

/**
 * Delete Content Asset
 */
export const deleteContentAsset = <ThrowOnError extends boolean = false>(options: Options<DeleteContentAssetData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentAssetResponses, DeleteContentAssetErrors, ThrowOnError>({ url: '/api/v2/content-assets/{asset_id}', ...options });

/**
 * Get an uploaded image asset by id
 */
export const getContentAsset = <ThrowOnError extends boolean = false>(options: Options<GetContentAssetData, ThrowOnError>) => (options.client ?? client).get<GetContentAssetResponses, GetContentAssetErrors, ThrowOnError>({ url: '/api/v2/content-assets/{asset_id}', ...options });

/**
 * Update Content Asset
 */
export const updateContentAsset = <ThrowOnError extends boolean = false>(options: Options<UpdateContentAssetData, ThrowOnError>) => (options.client ?? client).put<UpdateContentAssetResponses, UpdateContentAssetErrors, ThrowOnError>({
    url: '/api/v2/content-assets/{asset_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List rule groups that bundle hard rules for evaluation
 */
export const listContentRuleGroups = <ThrowOnError extends boolean = false>(options?: Options<ListContentRuleGroupsData, ThrowOnError>) => (options?.client ?? client).get<ListContentRuleGroupsResponses, unknown, ThrowOnError>({ url: '/api/v2/content-rules/groups', ...options });

/**
 * Create a new rule group that bundles hard rules for evaluation
 */
export const createContentRuleGroup = <ThrowOnError extends boolean = false>(options: Options<CreateContentRuleGroupData, ThrowOnError>) => (options.client ?? client).post<CreateContentRuleGroupResponses, CreateContentRuleGroupErrors, ThrowOnError>({
    url: '/api/v2/content-rules/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Permanently delete a rule group by id (hard delete)
 */
export const deleteContentRuleGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteContentRuleGroupData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentRuleGroupResponses, DeleteContentRuleGroupErrors, ThrowOnError>({ url: '/api/v2/content-rules/groups/{group_id}', ...options });

/**
 * Get a rule group with its list of rule IDs
 */
export const getContentRuleGroup = <ThrowOnError extends boolean = false>(options: Options<GetContentRuleGroupData, ThrowOnError>) => (options.client ?? client).get<GetContentRuleGroupResponses, GetContentRuleGroupErrors, ThrowOnError>({ url: '/api/v2/content-rules/groups/{group_id}', ...options });

/**
 * Update a rule group (rename, edit description, or replace its rule list)
 */
export const updateContentRuleGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateContentRuleGroupData, ThrowOnError>) => (options.client ?? client).put<UpdateContentRuleGroupResponses, UpdateContentRuleGroupErrors, ThrowOnError>({
    url: '/api/v2/content-rules/groups/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all hard rules that generated content must follow
 */
export const listContentRules = <ThrowOnError extends boolean = false>(options?: Options<ListContentRulesData, ThrowOnError>) => (options?.client ?? client).get<ListContentRulesResponses, unknown, ThrowOnError>({ url: '/api/v2/content-rules', ...options });

/**
 * Create a new hard rule that generated content must follow
 */
export const createContentRule = <ThrowOnError extends boolean = false>(options: Options<CreateContentRuleData, ThrowOnError>) => (options.client ?? client).post<CreateContentRuleResponses, CreateContentRuleErrors, ThrowOnError>({
    url: '/api/v2/content-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Permanently delete a hard rule by id (hard delete; cascades from group mappings)
 */
export const deleteContentRule = <ThrowOnError extends boolean = false>(options: Options<DeleteContentRuleData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentRuleResponses, DeleteContentRuleErrors, ThrowOnError>({ url: '/api/v2/content-rules/{rule_id}', ...options });

/**
 * Get a specific hard rule's text and group assignments
 */
export const getContentRule = <ThrowOnError extends boolean = false>(options: Options<GetContentRuleData, ThrowOnError>) => (options.client ?? client).get<GetContentRuleResponses, GetContentRuleErrors, ThrowOnError>({ url: '/api/v2/content-rules/{rule_id}', ...options });

/**
 * Update a hard rule's name, text, or group assignments
 */
export const updateContentRule = <ThrowOnError extends boolean = false>(options: Options<UpdateContentRuleData, ThrowOnError>) => (options.client ?? client).put<UpdateContentRuleResponses, UpdateContentRuleErrors, ThrowOnError>({
    url: '/api/v2/content-rules/{rule_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all content schemas that define generation variable structures
 */
export const listContentSchemas = <ThrowOnError extends boolean = false>(options?: Options<ListContentSchemasData, ThrowOnError>) => (options?.client ?? client).get<ListContentSchemasResponses, ListContentSchemasErrors, ThrowOnError>({ url: '/api/v2/content-schemas', ...options });

/**
 * Create Content Schema
 */
export const createContentSchema = <ThrowOnError extends boolean = false>(options: Options<CreateContentSchemaData, ThrowOnError>) => (options.client ?? client).post<CreateContentSchemaResponses, CreateContentSchemaErrors, ThrowOnError>({
    url: '/api/v2/content-schemas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Content Schema By Id
 */
export const deleteContentSchemaById = <ThrowOnError extends boolean = false>(options: Options<DeleteContentSchemaByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentSchemaByIdResponses, DeleteContentSchemaByIdErrors, ThrowOnError>({ url: '/api/v2/content-schemas/{schema_id}', ...options });

/**
 * Get a content schema's JSON schema and linked template
 */
export const getContentSchemaById = <ThrowOnError extends boolean = false>(options: Options<GetContentSchemaByIdData, ThrowOnError>) => (options.client ?? client).get<GetContentSchemaByIdResponses, GetContentSchemaByIdErrors, ThrowOnError>({ url: '/api/v2/content-schemas/{schema_id}', ...options });

/**
 * Update Content Schema
 */
export const updateContentSchema = <ThrowOnError extends boolean = false>(options: Options<UpdateContentSchemaData, ThrowOnError>) => (options.client ?? client).put<UpdateContentSchemaResponses, UpdateContentSchemaErrors, ThrowOnError>({
    url: '/api/v2/content-schemas/{schema_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List brand voice and tone guidelines for content generation
 */
export const listContentStyles = <ThrowOnError extends boolean = false>(options?: Options<ListContentStylesData, ThrowOnError>) => (options?.client ?? client).get<ListContentStylesResponses, ListContentStylesErrors, ThrowOnError>({ url: '/api/v2/content-styles', ...options });

/**
 * Create a new brand-guide style with a name, guideline text, and output type
 */
export const createContentStyle = <ThrowOnError extends boolean = false>(options: Options<CreateContentStyleData, ThrowOnError>) => (options.client ?? client).post<CreateContentStyleResponses, CreateContentStyleErrors, ThrowOnError>({
    url: '/api/v2/content-styles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Permanently delete a brand-guide style by id (hard delete)
 */
export const deleteContentStyle = <ThrowOnError extends boolean = false>(options: Options<DeleteContentStyleData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentStyleResponses, DeleteContentStyleErrors, ThrowOnError>({ url: '/api/v2/content-styles/{style_id}', ...options });

/**
 * Get a style guideline's full text and output type
 */
export const getContentStyle = <ThrowOnError extends boolean = false>(options: Options<GetContentStyleData, ThrowOnError>) => (options.client ?? client).get<GetContentStyleResponses, GetContentStyleErrors, ThrowOnError>({ url: '/api/v2/content-styles/{style_id}', ...options });

/**
 * Update an existing brand-guide style (name, guideline text, or output type)
 */
export const updateContentStyle = <ThrowOnError extends boolean = false>(options: Options<UpdateContentStyleData, ThrowOnError>) => (options.client ?? client).put<UpdateContentStyleResponses, UpdateContentStyleErrors, ThrowOnError>({
    url: '/api/v2/content-styles/{style_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all email/push content templates with type and name
 */
export const listContentTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListContentTemplatesData, ThrowOnError>) => (options?.client ?? client).get<ListContentTemplatesResponses, ListContentTemplatesErrors, ThrowOnError>({ url: '/api/v2/content-templates', ...options });

/**
 * Create Content Template
 */
export const createContentTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateContentTemplateData, ThrowOnError>) => (options.client ?? client).post<CreateContentTemplateResponses, CreateContentTemplateErrors, ThrowOnError>({
    url: '/api/v2/content-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Content Template By Id
 */
export const deleteContentTemplateById = <ThrowOnError extends boolean = false>(options: Options<DeleteContentTemplateByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentTemplateByIdResponses, DeleteContentTemplateByIdErrors, ThrowOnError>({ url: '/api/v2/content-templates/{template_id}', ...options });

/**
 * Get a content template's full details including HTML and config
 */
export const getContentTemplateById = <ThrowOnError extends boolean = false>(options: Options<GetContentTemplateByIdData, ThrowOnError>) => (options.client ?? client).get<GetContentTemplateByIdResponses, GetContentTemplateByIdErrors, ThrowOnError>({ url: '/api/v2/content-templates/{template_id}', ...options });

/**
 * Update Content Template
 */
export const updateContentTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateContentTemplateData, ThrowOnError>) => (options.client ?? client).put<UpdateContentTemplateResponses, UpdateContentTemplateErrors, ThrowOnError>({
    url: '/api/v2/content-templates/{template_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview a content template from an external source (Braze/Klaviyo) before importing
 */
export const previewContentTemplate = <ThrowOnError extends boolean = false>(options: Options<PreviewContentTemplateData, ThrowOnError>) => (options.client ?? client).post<PreviewContentTemplateResponses, PreviewContentTemplateErrors, ThrowOnError>({
    url: '/api/v2/content-templates/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a native Neon Blue email template
 *
 * Create OR update a Neon Blue email content template. Use this when the user asks to draft, design, edit, or save an email for their experiments.
 *
 * CREATE vs UPDATE:
 * * Omit `template_id` to CREATE a new template (`name` is required).
 * * Pass an existing neonblue template's `template_id` to UPDATE it. Updates are PARTIAL — only the fields you send change; omitted fields keep their current value. Get ids from list_content_templates / get_content_template_by_id.
 *
 * Content — provide EITHER `design_state` (preferred) OR `template_html`:
 * * `design_state` — the visual editor's block tree. Produces a template the user can edit block-by-block; the server renders it to HTML with the editor's own engine. See the design_state field description for the exact shape and supported blocks.
 * * `template_html` — a complete inline-styled HTML email. Faster, but opens as one non-editable block in the editor. Only use if you cannot produce design_state.
 *
 * Embed merge fields as Liquid `{{ nb.<snake_case_name> }}`. Every unique variable auto-registers on the linked content schema — no separate setup.
 *
 * Returns the template's `template_id` and `content_schema_id`.
 */
export const saveNeonblueTemplate = <ThrowOnError extends boolean = false>(options: Options<SaveNeonblueTemplateData, ThrowOnError>) => (options.client ?? client).post<SaveNeonblueTemplateResponses, SaveNeonblueTemplateErrors, ThrowOnError>({
    url: '/api/v2/content-templates/save-neonblue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync Content Template From Source
 *
 * Sync a content template from its external source (e.g. Braze, Klaviyo).
 */
export const syncContentTemplateFromSource = <ThrowOnError extends boolean = false>(options: Options<SyncContentTemplateFromSourceData, ThrowOnError>) => (options.client ?? client).post<SyncContentTemplateFromSourceResponses, SyncContentTemplateFromSourceErrors, ThrowOnError>({ url: '/api/v2/content-templates/{template_id}/sync', ...options });

/**
 * Generate sample parameter values for a template using AI
 */
export const generateSampleTemplateParameters = <ThrowOnError extends boolean = false>(options: Options<GenerateSampleTemplateParametersData, ThrowOnError>) => (options.client ?? client).post<GenerateSampleTemplateParametersResponses, GenerateSampleTemplateParametersErrors, ThrowOnError>({ url: '/api/v2/content-templates/{template_id}/sample-params', ...options });

/**
 * List variable type definitions (e.g. audience segments, product catalogs)
 */
export const listContentVariableTypes = <ThrowOnError extends boolean = false>(options?: Options<ListContentVariableTypesData, ThrowOnError>) => (options?.client ?? client).get<ListContentVariableTypesResponses, ListContentVariableTypesErrors, ThrowOnError>({ url: '/api/v2/content-variables/types', ...options });

/**
 * Create Content Variable Type
 */
export const createContentVariableType = <ThrowOnError extends boolean = false>(options: Options<CreateContentVariableTypeData, ThrowOnError>) => (options.client ?? client).post<CreateContentVariableTypeResponses, CreateContentVariableTypeErrors, ThrowOnError>({
    url: '/api/v2/content-variables/types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Content Variable Type
 */
export const deleteContentVariableType = <ThrowOnError extends boolean = false>(options: Options<DeleteContentVariableTypeData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentVariableTypeResponses, DeleteContentVariableTypeErrors, ThrowOnError>({ url: '/api/v2/content-variables/types/{type_id}', ...options });

/**
 * Get a variable type's schema and metadata
 */
export const getContentVariableType = <ThrowOnError extends boolean = false>(options: Options<GetContentVariableTypeData, ThrowOnError>) => (options.client ?? client).get<GetContentVariableTypeResponses, GetContentVariableTypeErrors, ThrowOnError>({ url: '/api/v2/content-variables/types/{type_id}', ...options });

/**
 * Update Content Variable Type
 */
export const updateContentVariableType = <ThrowOnError extends boolean = false>(options: Options<UpdateContentVariableTypeData, ThrowOnError>) => (options.client ?? client).put<UpdateContentVariableTypeResponses, UpdateContentVariableTypeErrors, ThrowOnError>({
    url: '/api/v2/content-variables/types/{type_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all variable values within a variable type
 */
export const listVariablesForType = <ThrowOnError extends boolean = false>(options: Options<ListVariablesForTypeData, ThrowOnError>) => (options.client ?? client).get<ListVariablesForTypeResponses, ListVariablesForTypeErrors, ThrowOnError>({ url: '/api/v2/content-variables/types/{type_id}/variables', ...options });

/**
 * Bulk Save Variables
 */
export const bulkSaveVariables = <ThrowOnError extends boolean = false>(options: Options<BulkSaveVariablesData, ThrowOnError>) => (options.client ?? client).put<BulkSaveVariablesResponses, BulkSaveVariablesErrors, ThrowOnError>({
    url: '/api/v2/content-variables/types/{type_id}/variables',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all content variables across types (flat)
 */
export const listContentVariables = <ThrowOnError extends boolean = false>(options?: Options<ListContentVariablesData, ThrowOnError>) => (options?.client ?? client).get<ListContentVariablesResponses, unknown, ThrowOnError>({ url: '/api/v2/content-variables', ...options });

/**
 * Create Content Variable
 */
export const createContentVariable = <ThrowOnError extends boolean = false>(options: Options<CreateContentVariableData, ThrowOnError>) => (options.client ?? client).post<CreateContentVariableResponses, CreateContentVariableErrors, ThrowOnError>({
    url: '/api/v2/content-variables',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Content Variable
 */
export const deleteContentVariable = <ThrowOnError extends boolean = false>(options: Options<DeleteContentVariableData, ThrowOnError>) => (options.client ?? client).delete<DeleteContentVariableResponses, DeleteContentVariableErrors, ThrowOnError>({ url: '/api/v2/content-variables/{variable_id}', ...options });

/**
 * Get a specific variable's value and type
 */
export const getContentVariable = <ThrowOnError extends boolean = false>(options: Options<GetContentVariableData, ThrowOnError>) => (options.client ?? client).get<GetContentVariableResponses, GetContentVariableErrors, ThrowOnError>({ url: '/api/v2/content-variables/{variable_id}', ...options });

/**
 * Update Content Variable
 */
export const updateContentVariable = <ThrowOnError extends boolean = false>(options: Options<UpdateContentVariableData, ThrowOnError>) => (options.client ?? client).put<UpdateContentVariableResponses, UpdateContentVariableErrors, ThrowOnError>({
    url: '/api/v2/content-variables/{variable_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve Variable Slugs
 *
 * Resolve variable IDs to slugs. Returns type and variable slug mappings.
 */
export const resolveVariableSlugs = <ThrowOnError extends boolean = false>(options: Options<ResolveVariableSlugsData, ThrowOnError>) => (options.client ?? client).post<ResolveVariableSlugsResponses, ResolveVariableSlugsErrors, ThrowOnError>({
    url: '/api/v2/content-variables/resolve-slugs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Source Templates
 *
 * List cached source templates for an integration, optionally filtered by source type.
 */
export const listSourceTemplates = <ThrowOnError extends boolean = false>(options: Options<ListSourceTemplatesData, ThrowOnError>) => (options.client ?? client).get<ListSourceTemplatesResponses, ListSourceTemplatesErrors, ThrowOnError>({ url: '/api/v2/source-templates', ...options });

/**
 * Sync Source Templates
 *
 * Start a background job to sync source templates for an integration.
 */
export const syncSourceTemplates = <ThrowOnError extends boolean = false>(options: Options<SyncSourceTemplatesData, ThrowOnError>) => (options.client ?? client).post<SyncSourceTemplatesResponses, SyncSourceTemplatesErrors, ThrowOnError>({
    url: '/api/v2/source-templates/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Source Types
 *
 * List available source types per integration type.
 */
export const listSourceTypes = <ThrowOnError extends boolean = false>(options?: Options<ListSourceTypesData, ThrowOnError>) => (options?.client ?? client).get<ListSourceTypesResponses, unknown, ThrowOnError>({ url: '/api/v2/source-templates/types', ...options });

/**
 * Upload an image and return its public URL
 */
export const uploadImage = <ThrowOnError extends boolean = false>(options: Options<UploadImageData, ThrowOnError>) => (options.client ?? client).post<UploadImageResponses, UploadImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v2/uploads/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Integrations
 *
 * List all integrations configured for the current partner.
 */
export const listIntegrations = <ThrowOnError extends boolean = false>(options?: Options<ListIntegrationsData, ThrowOnError>) => (options?.client ?? client).get<ListIntegrationsResponses, unknown, ThrowOnError>({ url: '/api/v2/integrations', ...options });

/**
 * Delete Integration
 *
 * Soft-delete an integration.
 */
export const deleteIntegration = <ThrowOnError extends boolean = false>(options: Options<DeleteIntegrationData, ThrowOnError>) => (options.client ?? client).delete<DeleteIntegrationResponses, DeleteIntegrationErrors, ThrowOnError>({ url: '/api/v2/integrations/{integration_id}', ...options });

/**
 * Update Integration
 *
 * Update an integration's name.
 */
export const updateIntegration = <ThrowOnError extends boolean = false>(options: Options<UpdateIntegrationData, ThrowOnError>) => (options.client ?? client).patch<UpdateIntegrationResponses, UpdateIntegrationErrors, ThrowOnError>({
    url: '/api/v2/integrations/{integration_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Klaviyo Integration
 *
 * Create a new Klaviyo integration via API key.
 */
export const createKlaviyoIntegration = <ThrowOnError extends boolean = false>(options: Options<CreateKlaviyoIntegrationData, ThrowOnError>) => (options.client ?? client).post<CreateKlaviyoIntegrationResponses, CreateKlaviyoIntegrationErrors, ThrowOnError>({
    url: '/api/v2/integrations/klaviyo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Klaviyo Oauth Initiate
 *
 * Generate a Klaviyo OAuth authorization URL (PKCE flow).
 */
export const klaviyoOauthInitiate = <ThrowOnError extends boolean = false>(options?: Options<KlaviyoOauthInitiateData, ThrowOnError>) => (options?.client ?? client).post<KlaviyoOauthInitiateResponses, unknown, ThrowOnError>({ url: '/api/v2/integrations/klaviyo/oauth/initiate', ...options });

/**
 * Klaviyo Oauth Callback
 *
 * Handle the Klaviyo OAuth redirect. Exchanges code for tokens and saves the integration.
 */
export const klaviyoOauthCallback = <ThrowOnError extends boolean = false>(options?: Options<KlaviyoOauthCallbackData, ThrowOnError>) => (options?.client ?? client).get<KlaviyoOauthCallbackResponses, KlaviyoOauthCallbackErrors, ThrowOnError>({ url: '/api/v2/integrations/klaviyo/oauth/callback', ...options });

/**
 * Create Braze Integration
 *
 * Create a new Braze integration via API key.
 */
export const createBrazeIntegration = <ThrowOnError extends boolean = false>(options: Options<CreateBrazeIntegrationData, ThrowOnError>) => (options.client ?? client).post<CreateBrazeIntegrationResponses, CreateBrazeIntegrationErrors, ThrowOnError>({
    url: '/api/v2/integrations/braze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Shopify Oauth Initiate
 *
 * Return the partner's Shopify merchant install link.
 *
 * The link is multi-store — the merchant picks which shop to install on
 * after clicking through.
 */
export const shopifyOauthInitiate = <ThrowOnError extends boolean = false>(options?: Options<ShopifyOauthInitiateData, ThrowOnError>) => (options?.client ?? client).post<ShopifyOauthInitiateResponses, unknown, ThrowOnError>({ url: '/api/v2/integrations/shopify/oauth/initiate', ...options });

/**
 * Shopify Install
 *
 * Handle Shopify's post-install ping (the partner's ``application_url``).
 *
 * Receives ``shop``/``hmac``/``host``/``timestamp`` (no ``code``). HMAC is
 * signed with the partner's client_secret. On success we kick off Step 2
 * by 3xx-redirecting to ``/admin/oauth/authorize``.
 */
export const shopifyInstall = <ThrowOnError extends boolean = false>(options: Options<ShopifyInstallData, ThrowOnError>) => (options.client ?? client).get<ShopifyInstallResponses, ShopifyInstallErrors, ThrowOnError>({ url: '/api/v2/integrations/shopify/{partner_id}/install', ...options });

/**
 * Shopify Oauth Callback
 *
 * Handle Shopify's authorize redirect.
 *
 * Shared across all partners — partner_id is recovered from the encrypted
 * state set in ``/install``. Verifies state + HMAC, exchanges the code for
 * an offline access token, persists ``ShopifyIntegration``, then redirects
 * to the frontend.
 */
export const shopifyOauthCallback = <ThrowOnError extends boolean = false>(options?: Options<ShopifyOauthCallbackData, ThrowOnError>) => (options?.client ?? client).get<ShopifyOauthCallbackResponses, unknown, ThrowOnError>({ url: '/api/v2/integrations/shopify/oauth/callback', ...options });

/**
 * Create Canto Integration
 *
 * Create a Canto integration via client_credentials.
 *
 * Verifies the credentials by minting an access token *before* persisting,
 * so bad creds surface as a 400 on the connect form rather than a silent
 * failure on the next sync.
 */
export const createCantoIntegration = <ThrowOnError extends boolean = false>(options: Options<CreateCantoIntegrationData, ThrowOnError>) => (options.client ?? client).post<CreateCantoIntegrationResponses, CreateCantoIntegrationErrors, ThrowOnError>({
    url: '/api/v2/integrations/canto',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Klaviyo Dashboard Integration
 *
 * Create a new Klaviyo dashboard integration (username + password + TOTP).
 *
 * Session cookies are harvested lazily on first use, so credentials are
 * not verified here — bad creds surface on the first dashboard call.
 */
export const createKlaviyoDashboardIntegration = <ThrowOnError extends boolean = false>(options: Options<CreateKlaviyoDashboardIntegrationData, ThrowOnError>) => (options.client ?? client).post<CreateKlaviyoDashboardIntegrationResponses, CreateKlaviyoDashboardIntegrationErrors, ThrowOnError>({
    url: '/api/v2/integrations/klaviyo-dashboard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Dynamic Image Integration
 */
export const createDynamicImageIntegration = <ThrowOnError extends boolean = false>(options: Options<CreateDynamicImageIntegrationData, ThrowOnError>) => (options.client ?? client).post<CreateDynamicImageIntegrationResponses, CreateDynamicImageIntegrationErrors, ThrowOnError>({
    url: '/api/v2/integrations/dynamic-image',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Dynamic Image Templates
 */
export const listDynamicImageTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListDynamicImageTemplatesData, ThrowOnError>) => (options?.client ?? client).get<ListDynamicImageTemplatesResponses, ListDynamicImageTemplatesErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/templates', ...options });

/**
 * Get Dynamic Image Template
 */
export const getDynamicImageTemplate = <ThrowOnError extends boolean = false>(options: Options<GetDynamicImageTemplateData, ThrowOnError>) => (options.client ?? client).get<GetDynamicImageTemplateResponses, GetDynamicImageTemplateErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/templates/{public_id}', ...options });

/**
 * List Dynamic Image Fonts
 */
export const listDynamicImageFonts = <ThrowOnError extends boolean = false>(options?: Options<ListDynamicImageFontsData, ThrowOnError>) => (options?.client ?? client).get<ListDynamicImageFontsResponses, unknown, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/fonts', ...options });

/**
 * List Dynamic Image Template Slices
 */
export const listDynamicImageTemplateSlices = <ThrowOnError extends boolean = false>(options: Options<ListDynamicImageTemplateSlicesData, ThrowOnError>) => (options.client ?? client).get<ListDynamicImageTemplateSlicesResponses, ListDynamicImageTemplateSlicesErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/templates/{public_id}/slices', ...options });

/**
 * Import Dynamic Image Template As Neonblue
 */
export const importDynamicImageTemplateAsNeonblue = <ThrowOnError extends boolean = false>(options: Options<ImportDynamicImageTemplateAsNeonblueData, ThrowOnError>) => (options.client ?? client).post<ImportDynamicImageTemplateAsNeonblueResponses, ImportDynamicImageTemplateAsNeonblueErrors, ThrowOnError>({
    url: '/api/v2/integrations/dynamic-image/templates/{public_id}/import-as-neonblue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resync Dynamic Image Template As Neonblue
 */
export const resyncDynamicImageTemplateAsNeonblue = <ThrowOnError extends boolean = false>(options: Options<ResyncDynamicImageTemplateAsNeonblueData, ThrowOnError>) => (options.client ?? client).post<ResyncDynamicImageTemplateAsNeonblueResponses, ResyncDynamicImageTemplateAsNeonblueErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/templates/{public_id}/resync', ...options });

/**
 * Convert Dynamic Image Template As Neonblue
 */
export const convertDynamicImageTemplateAsNeonblue = <ThrowOnError extends boolean = false>(options: Options<ConvertDynamicImageTemplateAsNeonblueData, ThrowOnError>) => (options.client ?? client).post<ConvertDynamicImageTemplateAsNeonblueResponses, ConvertDynamicImageTemplateAsNeonblueErrors, ThrowOnError>({
    url: '/api/v2/integrations/dynamic-image/templates/{public_id}/convert-as-neonblue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convert a Figma email design into a Neon Blue template
 *
 * Starts an asynchronous agent run that converts the Figma design at `figma_url` into a native Neon Blue email template and saves it. Returns a `run_id` immediately; poll `get_figma_convert_status` with that id until `status` is `done` (the response then carries the created `template_id`) or `failed`. Conversions typically take 5 to 20 minutes.
 */
export const convertFigmaUrlToTemplate = <ThrowOnError extends boolean = false>(options: Options<ConvertFigmaUrlToTemplateData, ThrowOnError>) => (options.client ?? client).post<ConvertFigmaUrlToTemplateResponses, ConvertFigmaUrlToTemplateErrors, ThrowOnError>({
    url: '/api/v2/integrations/dynamic-image/convert/figma-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List recent Figma conversion runs
 *
 * Recent Figma→Neon Blue conversion runs for this organization (most recent first, kept for 2 hours).
 */
export const listFigmaConvertRuns = <ThrowOnError extends boolean = false>(options?: Options<ListFigmaConvertRunsData, ThrowOnError>) => (options?.client ?? client).get<ListFigmaConvertRunsResponses, unknown, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/convert/runs', ...options });

/**
 * Get the status of a Figma conversion run
 *
 * Status of one Figma→Neon Blue conversion run. `status` is queued, running, done (with `template_id`), failed, or error. Runs expire after 2 hours.
 */
export const getFigmaConvertStatus = <ThrowOnError extends boolean = false>(options: Options<GetFigmaConvertStatusData, ThrowOnError>) => (options.client ?? client).get<GetFigmaConvertStatusResponses, GetFigmaConvertStatusErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/convert/{run_id}', ...options });

/**
 * Get Figma Convert Log
 */
export const getFigmaConvertLog = <ThrowOnError extends boolean = false>(options: Options<GetFigmaConvertLogData, ThrowOnError>) => (options.client ?? client).get<GetFigmaConvertLogResponses, GetFigmaConvertLogErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/convert/{run_id}/log', ...options });

/**
 * Get Figma Convert Session
 */
export const getFigmaConvertSession = <ThrowOnError extends boolean = false>(options: Options<GetFigmaConvertSessionData, ThrowOnError>) => (options.client ?? client).get<GetFigmaConvertSessionResponses, GetFigmaConvertSessionErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/convert/{run_id}/session', ...options });

/**
 * Stream Figma Convert
 */
export const streamFigmaConvert = <ThrowOnError extends boolean = false>(options: Options<StreamFigmaConvertData, ThrowOnError>) => (options.client ?? client).get<StreamFigmaConvertResponses, StreamFigmaConvertErrors, ThrowOnError>({ url: '/api/v2/integrations/dynamic-image/convert/{run_id}/stream', ...options });

/**
 * Create Snowflake Share Outbound Integration
 *
 * Create a new Snowflake outbound data-share integration.
 */
export const createSnowflakeShareOutboundIntegration = <ThrowOnError extends boolean = false>(options: Options<CreateSnowflakeShareOutboundIntegrationData, ThrowOnError>) => (options.client ?? client).post<CreateSnowflakeShareOutboundIntegrationResponses, CreateSnowflakeShareOutboundIntegrationErrors, ThrowOnError>({
    url: '/api/v2/integrations/snowflake-share-outbound',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Experiment Features
 */
export const listExperimentFeatures = <ThrowOnError extends boolean = false>(options?: Options<ListExperimentFeaturesData, ThrowOnError>) => (options?.client ?? client).get<ListExperimentFeaturesResponses, unknown, ThrowOnError>({ url: '/api/v2/experiments/features', ...options });

/**
 * List Experiment Metrics
 */
export const listExperimentMetrics = <ThrowOnError extends boolean = false>(options?: Options<ListExperimentMetricsData, ThrowOnError>) => (options?.client ?? client).get<ListExperimentMetricsResponses, unknown, ThrowOnError>({ url: '/api/v2/experiments/metrics', ...options });

/**
 * List experiments (live + completed). Filter by `status` to narrow (e.g. 'running'). For per-experiment detail or variant lists use `list_experiment_variants`; for a single variant's edit link use `get_experiment_variant_edit_url`.
 */
export const listExperiments = <ThrowOnError extends boolean = false>(options?: Options<ListExperimentsData, ThrowOnError>) => (options?.client ?? client).get<ListExperimentsResponses, ListExperimentsErrors, ThrowOnError>({ url: '/api/v2/experiments', ...options });

/**
 * Create Experiment
 */
export const createExperiment = <ThrowOnError extends boolean = false>(options: Options<CreateExperimentData, ThrowOnError>) => (options.client ?? client).post<CreateExperimentResponses, CreateExperimentErrors, ThrowOnError>({
    url: '/api/v2/experiments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Experiment Details
 */
export const getExperimentDetails = <ThrowOnError extends boolean = false>(options: Options<GetExperimentDetailsData, ThrowOnError>) => (options.client ?? client).get<GetExperimentDetailsResponses, GetExperimentDetailsErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/details', ...options });

/**
 * Delete Experiment
 */
export const deleteExperiment = <ThrowOnError extends boolean = false>(options: Options<DeleteExperimentData, ThrowOnError>) => (options.client ?? client).delete<DeleteExperimentResponses, DeleteExperimentErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}', ...options });

/**
 * Update Experiment
 */
export const updateExperiment = <ThrowOnError extends boolean = false>(options: Options<UpdateExperimentData, ThrowOnError>) => (options.client ?? client).patch<UpdateExperimentResponses, UpdateExperimentErrors, ThrowOnError>({
    url: '/api/v2/experiments/{experiment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Experiment Status
 */
export const setExperimentStatus = <ThrowOnError extends boolean = false>(options: Options<SetExperimentStatusData, ThrowOnError>) => (options.client ?? client).post<SetExperimentStatusResponses, SetExperimentStatusErrors, ThrowOnError>({
    url: '/api/v2/experiments/{experiment_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Variants
 */
export const removeExperimentVariants = <ThrowOnError extends boolean = false>(options: Options<RemoveExperimentVariantsData, ThrowOnError>) => (options.client ?? client).delete<RemoveExperimentVariantsResponses, RemoveExperimentVariantsErrors, ThrowOnError>({
    url: '/api/v2/experiments/{experiment_id}/variants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all variants of an experiment with full content. Each item returns variant_id, name, description, status, is_control, tags, edit_url, created_at, and updated_at. It also returns the variant's `template` (per-slot values such as subject, body, h1, cta, preview, plus an optional per-slot content_template_id override), `event_context_filter` (per-variant eligibility filter — which events this variant is allowed to render against), and `action_features` (ML covariates describing the action: channel, persona, lifecycle_stage, includes_discount, is_suppress, etc.). Use this to inspect or compare the actual content and metadata of every variant in an experiment.
 */
export const listExperimentVariants = <ThrowOnError extends boolean = false>(options: Options<ListExperimentVariantsData, ThrowOnError>) => (options.client ?? client).get<ListExperimentVariantsResponses, ListExperimentVariantsErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/variants', ...options });

/**
 * Update Variants
 */
export const updateExperimentVariants = <ThrowOnError extends boolean = false>(options: Options<UpdateExperimentVariantsData, ThrowOnError>) => (options.client ?? client).patch<UpdateExperimentVariantsResponses, UpdateExperimentVariantsErrors, ThrowOnError>({
    url: '/api/v2/experiments/{experiment_id}/variants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Variant
 */
export const createExperimentVariant = <ThrowOnError extends boolean = false>(options: Options<CreateExperimentVariantData, ThrowOnError>) => (options.client ?? client).post<CreateExperimentVariantResponses, CreateExperimentVariantErrors, ThrowOnError>({
    url: '/api/v2/experiments/{experiment_id}/variants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return the portal dashboard URL where a specific experiment variant can be edited. Use this when the user asks to edit, update, or modify a variant — return `edit_url` as a clickable link (absolute URL) so they can navigate to the editor.
 */
export const getExperimentVariantEditUrl = <ThrowOnError extends boolean = false>(options: Options<GetExperimentVariantEditUrlData, ThrowOnError>) => (options.client ?? client).get<GetExperimentVariantEditUrlResponses, GetExperimentVariantEditUrlErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/variants/{variant_id}/edit-url', ...options });

/**
 * Set Variant Status
 */
export const setExperimentVariantStatus = <ThrowOnError extends boolean = false>(options: Options<SetExperimentVariantStatusData, ThrowOnError>) => (options.client ?? client).post<SetExperimentVariantStatusResponses, SetExperimentVariantStatusErrors, ThrowOnError>({
    url: '/api/v2/experiments/{experiment_id}/variants/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Exposures By Day
 */
export const getExperimentExposuresByDay = <ThrowOnError extends boolean = false>(options: Options<GetExperimentExposuresByDayData, ThrowOnError>) => (options.client ?? client).get<GetExperimentExposuresByDayResponses, GetExperimentExposuresByDayErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/exposures-by-day', ...options });

/**
 * Get Experiment Metric Timeseries Daily
 */
export const getExperimentMetricTimeseriesDaily = <ThrowOnError extends boolean = false>(options: Options<GetExperimentMetricTimeseriesDailyData, ThrowOnError>) => (options.client ?? client).get<GetExperimentMetricTimeseriesDailyResponses, GetExperimentMetricTimeseriesDailyErrors, ThrowOnError>({ url: '/api/v2/experiments/metrics/timeseries-daily', ...options });

/**
 * Per-variant daily time series from MD_ tables. Returns daily total_units and sum_unit_value per variant for chart rendering. Requires metric_id query param.
 */
export const getExperimentMetricDailyByVariant = <ThrowOnError extends boolean = false>(options: Options<GetExperimentMetricDailyByVariantData, ThrowOnError>) => (options.client ?? client).get<GetExperimentMetricDailyByVariantResponses, GetExperimentMetricDailyByVariantErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/metrics/daily-by-variant', ...options });

/**
 * Analyst-written interpretive context for an experiment: title, audience, intent, metric label, metric explanation, and current read. Returns 404 if no context exists for the experiment.
 */
export const getExperimentContext = <ThrowOnError extends boolean = false>(options: Options<GetExperimentContextData, ThrowOnError>) => (options.client ?? client).get<GetExperimentContextResponses, GetExperimentContextErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/context', ...options });

/**
 * Execute a metric query for an experiment. Returns per-variant aggregated stats, bandit_analysis (IPW pairwise comparisons), gate_analysis (pooled treatment vs control contrast), and freshness metadata.
 */
export const executeExperimentMetric = <ThrowOnError extends boolean = false>(options: Options<ExecuteExperimentMetricData, ThrowOnError>) => (options.client ?? client).post<ExecuteExperimentMetricResponses, ExecuteExperimentMetricErrors, ThrowOnError>({
    url: '/api/v2/experiments/{experiment_id}/metrics/execute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Latest persisted variant report for an experiment (rank, recommendation, peer/evidence stats per variant × metric) plus per-variant Welch contrasts vs control over the latest epoch's window. Use to answer 'how is each variant doing?', 'which variants are leading?', or 'what does the report recommend?'.
 */
export const getExperimentVariantReport = <ThrowOnError extends boolean = false>(options: Options<GetExperimentVariantReportData, ThrowOnError>) => (options.client ?? client).get<GetExperimentVariantReportResponses, GetExperimentVariantReportErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/report', ...options });

/**
 * Stream Live Logs
 *
 * SSE endpoint for live log streaming via Redis pub/sub.
 *
 * Streams summary-level data (same shape as the ``/query`` endpoint).
 * The client fetches full details on demand via ``/entry/{stream_id}``.
 * All filtering (variant, assignment type) is done client-side.
 */
export const streamDiagnosticsLogs = <ThrowOnError extends boolean = false>(options: Options<StreamDiagnosticsLogsData, ThrowOnError>) => (options.client ?? client).get<StreamDiagnosticsLogsResponses, StreamDiagnosticsLogsErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/diagnostics/stream', ...options });

/**
 * Query Logs
 *
 * Query historical log summaries from the Redis stream.
 *
 * Returns lightweight summaries with ``stream_id`` for detail fetching.
 * All filtering (variant, assignment type) is done client-side.
 */
export const queryDiagnosticsLogs = <ThrowOnError extends boolean = false>(options: Options<QueryDiagnosticsLogsData, ThrowOnError>) => (options.client ?? client).get<QueryDiagnosticsLogsResponses, QueryDiagnosticsLogsErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/diagnostics/query', ...options });

/**
 * Get Log Entry
 *
 * Fetch the full log entry by Redis stream ID.
 */
export const getDiagnosticsLogEntry = <ThrowOnError extends boolean = false>(options: Options<GetDiagnosticsLogEntryData, ThrowOnError>) => (options.client ?? client).get<GetDiagnosticsLogEntryResponses, GetDiagnosticsLogEntryErrors, ThrowOnError>({ url: '/api/v2/experiments/{experiment_id}/diagnostics/entry/{stream_id}', ...options });

/**
 * List Jobs
 *
 * List all background jobs for the current partner within the result TTL window.
 */
export const listJobs = <ThrowOnError extends boolean = false>(options?: Options<ListJobsData, ThrowOnError>) => (options?.client ?? client).get<ListJobsResponses, unknown, ThrowOnError>({ url: '/api/v2/jobs', ...options });

/**
 * Get Job
 *
 * Get a single job by ID.
 */
export const getJob = <ThrowOnError extends boolean = false>(options: Options<GetJobData, ThrowOnError>) => (options.client ?? client).get<GetJobResponses, GetJobErrors, ThrowOnError>({ url: '/api/v2/jobs/{job_id}', ...options });

/**
 * List each configured experiment's primary-metric treatment vs control contrast over a date window — one ContrastRow per experiment with lift, p-value, significance, CI half-width, and underpowered flag, plus an experiment-name lookup. Use to answer 'which experiments are winning?' or 'are any experiments underpowered?'.
 */
export const listExperimentMetricsSummary = <ThrowOnError extends boolean = false>(options?: Options<ListExperimentMetricsSummaryData, ThrowOnError>) => (options?.client ?? client).get<ListExperimentMetricsSummaryResponses, ListExperimentMetricsSummaryErrors, ThrowOnError>({ url: '/api/v2/metrics/experiment-summaries', ...options });

/**
 * List Id Types
 */
export const listWarehouseIdTypes = <ThrowOnError extends boolean = false>(options?: Options<ListWarehouseIdTypesData, ThrowOnError>) => (options?.client ?? client).get<ListWarehouseIdTypesResponses, ListWarehouseIdTypesErrors, ThrowOnError>({ url: '/api/v2/warehouse/id-types', ...options });

/**
 * Create Id Type
 */
export const createWarehouseIdType = <ThrowOnError extends boolean = false>(options: Options<CreateWarehouseIdTypeData, ThrowOnError>) => (options.client ?? client).post<CreateWarehouseIdTypeResponses, CreateWarehouseIdTypeErrors, ThrowOnError>({
    url: '/api/v2/warehouse/id-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Id Type By Id
 */
export const deleteWarehouseIdType = <ThrowOnError extends boolean = false>(options: Options<DeleteWarehouseIdTypeData, ThrowOnError>) => (options.client ?? client).delete<DeleteWarehouseIdTypeResponses, DeleteWarehouseIdTypeErrors, ThrowOnError>({ url: '/api/v2/warehouse/id-types/{id_type_id}', ...options });

/**
 * Get Id Type By Id
 */
export const getWarehouseIdType = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseIdTypeData, ThrowOnError>) => (options.client ?? client).get<GetWarehouseIdTypeResponses, GetWarehouseIdTypeErrors, ThrowOnError>({ url: '/api/v2/warehouse/id-types/{id_type_id}', ...options });

/**
 * Update Id Type
 */
export const updateWarehouseIdType = <ThrowOnError extends boolean = false>(options: Options<UpdateWarehouseIdTypeData, ThrowOnError>) => (options.client ?? client).put<UpdateWarehouseIdTypeResponses, UpdateWarehouseIdTypeErrors, ThrowOnError>({
    url: '/api/v2/warehouse/id-types/{id_type_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Source Tables
 */
export const listWarehouseSourceTables = <ThrowOnError extends boolean = false>(options?: Options<ListWarehouseSourceTablesData, ThrowOnError>) => (options?.client ?? client).get<ListWarehouseSourceTablesResponses, ListWarehouseSourceTablesErrors, ThrowOnError>({ url: '/api/v2/warehouse/source-tables', ...options });

/**
 * Create Source Table
 */
export const createWarehouseSourceTable = <ThrowOnError extends boolean = false>(options: Options<CreateWarehouseSourceTableData, ThrowOnError>) => (options.client ?? client).post<CreateWarehouseSourceTableResponses, CreateWarehouseSourceTableErrors, ThrowOnError>({
    url: '/api/v2/warehouse/source-tables',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Source Table By Id
 */
export const deleteWarehouseSourceTable = <ThrowOnError extends boolean = false>(options: Options<DeleteWarehouseSourceTableData, ThrowOnError>) => (options.client ?? client).delete<DeleteWarehouseSourceTableResponses, DeleteWarehouseSourceTableErrors, ThrowOnError>({ url: '/api/v2/warehouse/source-tables/{source_table_id}', ...options });

/**
 * Get Source Table By Id
 */
export const getWarehouseSourceTable = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseSourceTableData, ThrowOnError>) => (options.client ?? client).get<GetWarehouseSourceTableResponses, GetWarehouseSourceTableErrors, ThrowOnError>({ url: '/api/v2/warehouse/source-tables/{source_table_id}', ...options });

/**
 * Update Source Table
 */
export const updateWarehouseSourceTable = <ThrowOnError extends boolean = false>(options: Options<UpdateWarehouseSourceTableData, ThrowOnError>) => (options.client ?? client).put<UpdateWarehouseSourceTableResponses, UpdateWarehouseSourceTableErrors, ThrowOnError>({
    url: '/api/v2/warehouse/source-tables/{source_table_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Feature Specs
 */
export const listWarehouseFeatureSpecs = <ThrowOnError extends boolean = false>(options?: Options<ListWarehouseFeatureSpecsData, ThrowOnError>) => (options?.client ?? client).get<ListWarehouseFeatureSpecsResponses, ListWarehouseFeatureSpecsErrors, ThrowOnError>({ url: '/api/v2/warehouse/features/specs', ...options });

/**
 * Create Feature Spec
 */
export const createWarehouseFeatureSpec = <ThrowOnError extends boolean = false>(options: Options<CreateWarehouseFeatureSpecData, ThrowOnError>) => (options.client ?? client).post<CreateWarehouseFeatureSpecResponses, CreateWarehouseFeatureSpecErrors, ThrowOnError>({
    url: '/api/v2/warehouse/features/specs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Feature Store
 */
export const getWarehouseStore = <ThrowOnError extends boolean = false>(options?: Options<GetWarehouseStoreData, ThrowOnError>) => (options?.client ?? client).get<GetWarehouseStoreResponses, unknown, ThrowOnError>({ url: '/api/v2/warehouse/features/store', ...options });

/**
 * Preview Feature Query
 */
export const previewWarehouseFeature = <ThrowOnError extends boolean = false>(options: Options<PreviewWarehouseFeatureData, ThrowOnError>) => (options.client ?? client).post<PreviewWarehouseFeatureResponses, PreviewWarehouseFeatureErrors, ThrowOnError>({
    url: '/api/v2/warehouse/features/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Feature Spec
 */
export const getWarehouseFeatureSpec = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseFeatureSpecData, ThrowOnError>) => (options.client ?? client).get<GetWarehouseFeatureSpecResponses, GetWarehouseFeatureSpecErrors, ThrowOnError>({ url: '/api/v2/warehouse/features/specs/{feature_id}', ...options });

/**
 * Update Feature Spec
 */
export const updateWarehouseFeatureSpec = <ThrowOnError extends boolean = false>(options: Options<UpdateWarehouseFeatureSpecData, ThrowOnError>) => (options.client ?? client).put<UpdateWarehouseFeatureSpecResponses, UpdateWarehouseFeatureSpecErrors, ThrowOnError>({
    url: '/api/v2/warehouse/features/specs/{feature_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Metric Query
 */
export const previewWarehouseMetric = <ThrowOnError extends boolean = false>(options: Options<PreviewWarehouseMetricData, ThrowOnError>) => (options.client ?? client).post<PreviewWarehouseMetricResponses, PreviewWarehouseMetricErrors, ThrowOnError>({
    url: '/api/v2/warehouse/metrics/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Execute Metric Timeseries
 */
export const executeWarehouseMetricTimeseries = <ThrowOnError extends boolean = false>(options: Options<ExecuteWarehouseMetricTimeseriesData, ThrowOnError>) => (options.client ?? client).post<ExecuteWarehouseMetricTimeseriesResponses, ExecuteWarehouseMetricTimeseriesErrors, ThrowOnError>({
    url: '/api/v2/warehouse/metrics/execute-timeseries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Metrics
 */
export const listWarehouseMetrics = <ThrowOnError extends boolean = false>(options?: Options<ListWarehouseMetricsData, ThrowOnError>) => (options?.client ?? client).get<ListWarehouseMetricsResponses, ListWarehouseMetricsErrors, ThrowOnError>({ url: '/api/v2/warehouse/metrics', ...options });

/**
 * Create Metric
 */
export const createWarehouseMetric = <ThrowOnError extends boolean = false>(options: Options<CreateWarehouseMetricData, ThrowOnError>) => (options.client ?? client).post<CreateWarehouseMetricResponses, CreateWarehouseMetricErrors, ThrowOnError>({
    url: '/api/v2/warehouse/metrics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Metric By Id
 */
export const deleteWarehouseMetric = <ThrowOnError extends boolean = false>(options: Options<DeleteWarehouseMetricData, ThrowOnError>) => (options.client ?? client).delete<DeleteWarehouseMetricResponses, DeleteWarehouseMetricErrors, ThrowOnError>({ url: '/api/v2/warehouse/metrics/{metric_id}', ...options });

/**
 * Get Metric By Id
 */
export const getWarehouseMetric = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseMetricData, ThrowOnError>) => (options.client ?? client).get<GetWarehouseMetricResponses, GetWarehouseMetricErrors, ThrowOnError>({ url: '/api/v2/warehouse/metrics/{metric_id}', ...options });

/**
 * Update Metric
 */
export const updateWarehouseMetric = <ThrowOnError extends boolean = false>(options: Options<UpdateWarehouseMetricData, ThrowOnError>) => (options.client ?? client).put<UpdateWarehouseMetricResponses, UpdateWarehouseMetricErrors, ThrowOnError>({
    url: '/api/v2/warehouse/metrics/{metric_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 4-sentence experiment recap: audience, design, result, takeaway. 3-5 LLM calls.
 */
export const getReportInsightsRecap = <ThrowOnError extends boolean = false>(options: Options<GetReportInsightsRecapData, ThrowOnError>) => (options.client ?? client).get<GetReportInsightsRecapResponses, GetReportInsightsRecapErrors, ThrowOnError>({ url: '/api/v2/report-insights/{experiment_id}/recap', ...options });

/**
 * Variant status and metric data (included in /insights). Fast, no LLM calls.
 */
export const getReportInsightsChart = <ThrowOnError extends boolean = false>(options: Options<GetReportInsightsChartData, ThrowOnError>) => (options.client ?? client).get<GetReportInsightsChartResponses, GetReportInsightsChartErrors, ThrowOnError>({ url: '/api/v2/report-insights/{experiment_id}/chart', ...options });

/**
 * Executive summary only (included in /insights). One LLM call.
 */
export const getReportInsightsSummary = <ThrowOnError extends boolean = false>(options: Options<GetReportInsightsSummaryData, ThrowOnError>) => (options.client ?? client).get<GetReportInsightsSummaryResponses, GetReportInsightsSummaryErrors, ThrowOnError>({ url: '/api/v2/report-insights/{experiment_id}/summary', ...options });

/**
 * Content pattern analysis only (included in /insights). One LLM call.
 */
export const getReportInsightsAnalysis = <ThrowOnError extends boolean = false>(options: Options<GetReportInsightsAnalysisData, ThrowOnError>) => (options.client ?? client).get<GetReportInsightsAnalysisResponses, GetReportInsightsAnalysisErrors, ThrowOnError>({ url: '/api/v2/report-insights/{experiment_id}/analysis', ...options });

/**
 * Testable hypotheses only (included in /insights). Runs analysis first, then two more LLM calls.
 */
export const getReportInsightsHypotheses = <ThrowOnError extends boolean = false>(options: Options<GetReportInsightsHypothesesData, ThrowOnError>) => (options.client ?? client).get<GetReportInsightsHypothesesResponses, GetReportInsightsHypothesesErrors, ThrowOnError>({ url: '/api/v2/report-insights/{experiment_id}/hypotheses', ...options });

/**
 * Full report insights — use this unless you only need one section. Runs chart + summary + analysis + hypotheses in parallel where possible.
 */
export const getReportInsights = <ThrowOnError extends boolean = false>(options: Options<GetReportInsightsData, ThrowOnError>) => (options.client ?? client).get<GetReportInsightsResponses, GetReportInsightsErrors, ThrowOnError>({ url: '/api/v2/report-insights/{experiment_id}/insights', ...options });

/**
 * Treatment effects and variant rankings for coterie flow-split experiments
 */
export const getVariantReport = <ThrowOnError extends boolean = false>(options?: Options<GetVariantReportData, ThrowOnError>) => (options?.client ?? client).get<GetVariantReportResponses, unknown, ThrowOnError>({ url: '/api/v2/variant-report', ...options });

/**
 * Treatment effects and variant rankings from E_KLAVIYO_FLOW_SPLIT_EVALUATIONS
 */
export const getExperimentVariantMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetExperimentVariantMetricsData, ThrowOnError>) => (options?.client ?? client).get<GetExperimentVariantMetricsResponses, unknown, ThrowOnError>({ url: '/api/v2/experiment-variant-metrics', ...options });

/**
 * Root
 *
 * Root endpoint.
 */
export const root = <ThrowOnError extends boolean = false>(options?: Options<RootData, ThrowOnError>) => (options?.client ?? client).get<RootResponses, unknown, ThrowOnError>({ url: '/', ...options });

/**
 * Liveness
 *
 * Liveness probe - checks if the service is running.
 */
export const healthLiveness = <ThrowOnError extends boolean = false>(options?: Options<HealthLivenessData, ThrowOnError>) => (options?.client ?? client).get<HealthLivenessResponses, unknown, ThrowOnError>({ url: '/health/liveness', ...options });

/**
 * Readiness
 *
 * Readiness probe — checks DB connectivity for every partner.
 *
 * Returns 200 if all checks pass, 503 if any critical check fails.
 * Does NOT require authentication (K8s probes).
 */
export const healthReadiness = <ThrowOnError extends boolean = false>(options?: Options<HealthReadinessData, ThrowOnError>) => (options?.client ?? client).get<HealthReadinessResponses, unknown, ThrowOnError>({ url: '/health/readiness', ...options });
